module.exports = __webpack_public_path__ + "img/student-related-services.ed3acc73.svg";